export type SectionId =
  | 'start'
  | 'my-information'
  | 'property'
  | 'income'
  | 'deductions'
  | 'foreign-reporting'
  | 'summary'
  | 'submission';

export interface SidebarSectionConfig {
  id: SectionId;
  label: string;
  /** Match API screen `category` (lowercased) */
  categoryMatchers: string[];
}

export function resolveSectionId(apiCategory: string, sections: SidebarSectionConfig[]): SectionId {
  const c = (apiCategory || '').toLowerCase().trim();
  for (const s of sections) {
    for (const m of s.categoryMatchers) {
      if (c === m || c.includes(m)) {
        return s.id;
      }
    }
  }
  return 'start';
}

/** Order matches design (top → bottom). Matchers ordered before broader ones where needed. */
export const SIDEBAR_SECTIONS: SidebarSectionConfig[] = [
  { id: 'start', label: 'Start', categoryMatchers: ['onboarding', 'getting started', 'getting-started', 'other'] },
  {
    id: 'my-information',
    label: 'My Information',
    categoryMatchers: ['personal-info', 'personal info', 'personal', 'family', 'residency', 'my info'],
  },
  { id: 'income', label: 'Income', categoryMatchers: ['income', 'housing'] },
  { id: 'deductions', label: 'Deductions', categoryMatchers: ['deduction'] },
  { id: 'foreign-reporting', label: 'Foreign Reporting', categoryMatchers: ['foreign'] },
  { id: 'summary', label: 'Summary', categoryMatchers: ['summary', 'review'] },
  { id: 'submission', label: 'Submission', categoryMatchers: ['submission', 'payment'] },
];

/**
 * Heuristic non-resident sidebar: split housing into Property and omit empty sections.
 * This is intended to be used only when the screen list contains no deductions and no foreign-reporting screens.
 */
export const SIDEBAR_SECTIONS_HEURISTIC_NON_RESIDENT: SidebarSectionConfig[] = [
  { id: 'start', label: 'Start', categoryMatchers: ['onboarding', 'getting started', 'getting-started', 'other'] },
  {
    id: 'my-information',
    label: 'My Information',
    categoryMatchers: ['personal-info', 'personal info', 'personal', 'family', 'residency', 'my info'],
  },
  { id: 'property', label: 'Property', categoryMatchers: ['housing'] },
  { id: 'income', label: 'Income', categoryMatchers: ['income'] },
  { id: 'summary', label: 'Summary', categoryMatchers: ['summary', 'review'] },
  { id: 'submission', label: 'Submission', categoryMatchers: ['submission', 'payment'] },
];
